import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
import adminApi from '../../services/adminApi';
import NotificationContainer from '../Notification/NotificationContainer';

const AdminUsers = ({ type }) => {
  // const location = useLocation();
  // const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    user_type: type || 'all',
    status: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('desc');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
    user_type: 'customer',
    is_active: true,
    is_verified: true
  });

  // Système de notifications
  const addNotification = (message, type = 'success') => {
    const id = Date.now() + Math.random();
    setNotifications(prev => [...prev, { id, message, type }]);
    return id;
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  // Charger les données au montage du composant
  useEffect(() => {
    loadData();
  }, []);

  // Appliquer le filtre de type si fourni
  useEffect(() => {
    if (type) {
      setFilters(prev => ({
        ...prev,
        user_type: type === 'buyers' ? 'customer' : type
      }));
    }
  }, [type]);

  // Fonction pour obtenir le badge de type utilisateur
  const getUserTypeBadge = (userType) => {
    const typeMap = {
      customer: { label: 'Acheteur', class: 'badge-primary' },
      supplier: { label: 'Fournisseur', class: 'badge-info' },
      delivery_person: { label: 'Livreur', class: 'badge-warning' },
      admin: { label: 'Administrateur', class: 'badge-danger' }
    };
    const typeInfo = typeMap[userType] || { label: userType, class: 'badge-secondary' };
    return <span className={`badge ${typeInfo.class}`}>{typeInfo.label}</span>;
  };

  // Fonction pour obtenir le badge de statut
  const getStatusBadge = (isActive) => {
    return isActive ? (
      <span className="badge badge-success">Actif</span>
    ) : (
      <span className="badge badge-danger">Inactif</span>
    );
  };

  // Fonction pour gérer le tri
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('desc');
    }
  };

  // Appliquer les filtres et le tri
  useEffect(() => {
    let filtered = users;

    if (filters.search) {
      filtered = filtered.filter(user =>
        user.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
        user.email?.toLowerCase().includes(filters.search.toLowerCase()) ||
        user.phone?.toLowerCase().includes(filters.search.toLowerCase())
      );
    }

    if (filters.user_type && filters.user_type !== 'all') {
      filtered = filtered.filter(user => user.user_type === filters.user_type);
    }

    if (filters.status) {
      filtered = filtered.filter(user =>
        filters.status === 'active' ? user.is_active : !user.is_active
      );
    }

    // Appliquer le tri
    if (sortField) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortField) {
          case 'name':
            aValue = (a.name || '').toLowerCase();
            bValue = (b.name || '').toLowerCase();
            break;
          case 'email':
            aValue = (a.email || '').toLowerCase();
            bValue = (b.email || '').toLowerCase();
            break;
          case 'user_type':
            aValue = a.user_type || '';
            bValue = b.user_type || '';
            break;
          case 'status':
            aValue = a.is_active ? 1 : 0;
            bValue = b.is_active ? 1 : 0;
            break;
          case 'created_at':
            aValue = new Date(a.created_at || 0).getTime();
            bValue = new Date(b.created_at || 0).getTime();
            break;
          default:
            return 0;
        }

        if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    }

    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [users, filters, sortField, sortOrder]);

  const loadData = async () => {
    try {
      setLoading(true);
      const userType = filters.user_type === 'all' ? 'all' : filters.user_type;
      const usersData = await adminApi.getUsers(userType);
      // La réponse peut être directement un tableau ou dans data avec pagination
      let usersList = [];
      if (Array.isArray(usersData)) {
        usersList = usersData;
      } else if (usersData?.data) {
        // Si c'est une pagination Laravel
        usersList = Array.isArray(usersData.data) ? usersData.data : usersData.data.data || [];
      }
      setUsers(usersList);
    } catch (error) {
      console.error('Erreur lors du chargement des utilisateurs:', error);
      addNotification('Erreur lors du chargement des utilisateurs', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Recharger quand le filtre user_type change
  useEffect(() => {
    if (!loading) {
      loadData();
    }
  }, [filters.user_type]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    setFilters({
      search: '',
      user_type: type || 'all',
      status: ''
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      password: '',
      phone: '',
      user_type: 'customer',
      is_active: true,
      is_verified: true
    });
    setEditingUser(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const userData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || null,
        user_type: formData.user_type,
        is_active: formData.is_active === true || formData.is_active === 'true',
        is_verified: formData.is_verified === true || formData.is_verified === 'true',
      };

      // Ajouter le mot de passe seulement si c'est une création ou s'il est modifié
      if (!editingUser || formData.password) {
        if (!formData.password || formData.password.length < 8) {
          addNotification('Le mot de passe doit contenir au moins 8 caractères', 'error');
          return;
        }
        userData.password = formData.password;
      }

      let savedUser;
      if (editingUser) {
        const response = await adminApi.updateUser(editingUser.id, userData);
        savedUser = response?.data || response;

        if (!savedUser || !savedUser.id) {
          throw new Error('Réponse invalide du serveur');
        }

        setUsers(prev => prev.map(user =>
          user.id === editingUser.id ? savedUser : user
        ));
        addNotification('Utilisateur modifié avec succès', 'success');
      } else {
        // Pour la création, seuls les fournisseurs et livreurs peuvent être créés
        if (userData.user_type === 'customer') {
          addNotification('Les acheteurs doivent s\'inscrire eux-mêmes. Vous ne pouvez créer que des fournisseurs ou des livreurs.', 'warning');
          return;
        }

        const response = await adminApi.createUser(userData);
        savedUser = response?.data || response;

        if (!savedUser || !savedUser.id) {
          throw new Error('Réponse invalide du serveur');
        }

        setUsers(prev => [...prev, savedUser]);
        addNotification('Utilisateur créé avec succès', 'success');
      }

      setShowAddModal(false);
      resetForm();
      await loadData();
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Erreur lors de la sauvegarde';
      addNotification(errorMessage, 'error');
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      name: user.name || '',
      email: user.email || '',
      password: '', // Ne pas pré-remplir le mot de passe
      phone: user.phone || '',
      user_type: user.user_type || 'customer',
      is_active: user.is_active !== undefined ? user.is_active : true,
      is_verified: user.is_verified !== undefined ? user.is_verified : true
    });
    setShowAddModal(true);
  };

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setShowDetailsModal(true);
  };

  const handleDeleteClick = (user) => {
    setSelectedUser(user);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!selectedUser) return;

    try {
      await adminApi.deleteUser(selectedUser.id);
      setUsers(prev => prev.filter(user => user.id !== selectedUser.id));
      setShowDeleteModal(false);
      setSelectedUser(null);
      addNotification('Utilisateur supprimé avec succès', 'success');
      await loadData();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Erreur lors de la suppression';
      addNotification(errorMessage, 'error');
    }
  };

  const toggleStatus = async (id) => {
    try {
      const user = users.find(u => u.id === id);
      const updatedUser = await adminApi.updateUser(id, {
        ...user,
        is_active: !user.is_active
      });
      const savedUser = updatedUser.data || updatedUser;
      setUsers(prev => prev.map(u => u.id === id ? savedUser : u));
      addNotification(`Utilisateur ${!user.is_active ? 'activé' : 'désactivé'} avec succès`, 'success');
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      addNotification('Erreur lors de la mise à jour du statut', 'error');
    }
  };

  // Fonction pour exporter les utilisateurs en CSV
  const handleExport = () => {
    try {
      const usersToExport = filteredUsers.length > 0 ? filteredUsers : users;

      if (usersToExport.length === 0) {
        addNotification('Aucun utilisateur à exporter', 'warning');
        return;
      }

      const headers = [
        'ID',
        'Nom',
        'Email',
        'Téléphone',
        'Type',
        'Statut',
        'Vérifié',
        'Date de création'
      ];

      const csvRows = usersToExport.map(user => {
        const row = [
          user.id || '',
          `"${(user.name || '').replace(/"/g, '""')}"`,
          `"${(user.email || '').replace(/"/g, '""')}"`,
          user.phone || '',
          user.user_type || '',
          user.is_active ? 'Actif' : 'Inactif',
          user.is_verified ? 'Oui' : 'Non',
          user.created_at ? new Date(user.created_at).toLocaleDateString('fr-FR') : ''
        ];
        return row.join(',');
      });

      const csvContent = [
        headers.join(','),
        ...csvRows
      ].join('\n');

      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);

      const date = new Date().toISOString().split('T')[0];
      const filename = `utilisateurs_${date}.csv`;
      link.setAttribute('download', filename);

      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      addNotification(`${usersToExport.length} utilisateur(s) exporté(s) avec succès`, 'success');
    } catch (error) {
      console.error('Erreur lors de l\'export:', error);
      addNotification('Erreur lors de l\'export des utilisateurs', 'error');
    }
  };

  // Fonction pour formater les dates
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, endIndex);

  if (loading) {
    return (
      <div className="fade-in">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
            <p className="mt-4 text-gray-600">Chargement des utilisateurs...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in">
      <NotificationContainer notifications={notifications} onRemove={removeNotification} />

      <div className="breadcrumb">
        <a href="/admin" className="breadcrumb-item">Dashboard</a>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item">Gestion</span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-item">Utilisateurs</span>
      </div>

      <div className="page-header">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="page-title">Gestion des Utilisateurs</h1>
            <p className="page-subtitle">
              {type === 'buyers' || filters.user_type === 'customer'
                ? 'Gérer les utilisateurs acheteurs du marché agricole'
                : 'Gérer tous les utilisateurs (acheteurs, fournisseurs, livreurs)'}
            </p>
          </div>
          <button
            onClick={() => {
              resetForm();
              setShowAddModal(true);
            }}
            className="btn btn-primary"
          >
            <svg className="w-5 h-5 mr-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Créer un utilisateur
          </button>
        </div>
      </div>

      {/* Filtres et Actions */}
      <div className="mb-6 flex flex-wrap items-center gap-4">
        <div className="flex flex-wrap gap-3 flex-1">
          {/* Recherche */}
          <input
            type="text"
            name="search"
            placeholder="Rechercher un utilisateur..."
            value={filters.search}
            onChange={handleFilterChange}
            className="search-input"
          />

          {/* Filtre par type */}
          <select
            name="user_type"
            value={filters.user_type}
            onChange={handleFilterChange}
            className="search-input"
          >
            <option value="all">Tous les types</option>
            <option value="customer">Acheteurs</option>
            <option value="supplier">Fournisseurs</option>
            <option value="delivery_person">Livreurs</option>
            <option value="admin">Administrateurs</option>
          </select>

          {/* Filtre par statut */}
          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            className="search-input"
          >
            <option value="">Tous les statuts</option>
            <option value="active">Actifs</option>
            <option value="inactive">Inactifs</option>
          </select>

          {/* Bouton pour effacer les filtres */}
          <button
            onClick={clearFilters}
            className="btn btn-secondary text-sm"
          >
            Effacer
          </button>
        </div>
      </div>

      {/* Users DataTable */}
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">
            Liste des Utilisateurs
            <span className="text-sm text-gray-500 ml-2">
              ({filteredUsers.length} utilisateur{filteredUsers.length > 1 ? 's' : ''})
            </span>
          </h3>
          <div className="table-actions">
            <button
              onClick={handleExport}
              className="btn btn-secondary"
              disabled={filteredUsers.length === 0}
            >
              <svg className="w-4 h-4 mr-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Exporter CSV
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <button
                    onClick={() => handleSort('name')}
                    className="flex items-center gap-2 hover:text-green-600 transition-colors"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontWeight: 'inherit', color: 'inherit' }}
                  >
                    Nom
                    {sortField === 'name' && (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {sortOrder === 'asc' ? (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        )}
                      </svg>
                    )}
                  </button>
                </th>
                <th>
                  <button
                    onClick={() => handleSort('email')}
                    className="flex items-center gap-2 hover:text-green-600 transition-colors"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontWeight: 'inherit', color: 'inherit' }}
                  >
                    Email
                    {sortField === 'email' && (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {sortOrder === 'asc' ? (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        )}
                      </svg>
                    )}
                  </button>
                </th>
                <th>Téléphone</th>
                <th>
                  <button
                    onClick={() => handleSort('user_type')}
                    className="flex items-center gap-2 hover:text-green-600 transition-colors"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontWeight: 'inherit', color: 'inherit' }}
                  >
                    Type
                    {sortField === 'user_type' && (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {sortOrder === 'asc' ? (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        )}
                      </svg>
                    )}
                  </button>
                </th>
                <th>
                  <button
                    onClick={() => handleSort('status')}
                    className="flex items-center gap-2 hover:text-green-600 transition-colors"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontWeight: 'inherit', color: 'inherit' }}
                  >
                    Statut
                    {sortField === 'status' && (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {sortOrder === 'asc' ? (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        )}
                      </svg>
                    )}
                  </button>
                </th>
                <th>
                  <button
                    onClick={() => handleSort('created_at')}
                    className="flex items-center gap-2 hover:text-green-600 transition-colors"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontWeight: 'inherit', color: 'inherit' }}
                  >
                    Date d'inscription
                    {sortField === 'created_at' && (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {sortOrder === 'asc' ? (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                        ) : (
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        )}
                      </svg>
                    )}
                  </button>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-8 text-gray-500">
                    <div className="flex flex-col items-center">
                      <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                      </svg>
                      <p className="text-lg font-medium">Aucun utilisateur trouvé</p>
                      <p className="text-sm">Les utilisateurs apparaîtront ici</p>
                    </div>
                  </td>
                </tr>
              ) : (
                currentUsers.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div className="font-medium text-gray-900 dark:text-white">
                        {user.name || 'N/A'}
                      </div>
                    </td>
                    <td>
                      <div className="text-sm text-gray-900 dark:text-white">
                        {user.email || 'N/A'}
                      </div>
                    </td>
                    <td className="text-sm text-gray-500">
                      {user.phone || 'N/A'}
                    </td>
                    <td>
                      {getUserTypeBadge(user.user_type)}
                    </td>
                    <td>
                      {getStatusBadge(user.is_active)}
                    </td>
                    <td className="text-sm text-gray-500">
                      {formatDate(user.created_at)}
                    </td>
                    <td>
                      <div className="flex items-center gap-2 flex-wrap">
                        {/* Bouton Détails - Bleu/Info */}
                        <button
                          onClick={() => handleViewDetails(user)}
                          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white rounded-lg transition-colors"
                          style={{ backgroundColor: '#3b82f6' }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
                          title="Voir les détails"
                        >
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          Détails
                        </button>

                        {/* Bouton Modifier - Orange/Warning */}
                        <button
                          onClick={() => handleEdit(user)}
                          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white rounded-lg transition-colors"
                          style={{ backgroundColor: '#f59e0b' }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#d97706'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#f59e0b'}
                          title="Modifier"
                        >
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                          Modifier
                        </button>

                        {/* Bouton Activer/Désactiver - Vert ou Gris */}
                        <button
                          onClick={() => toggleStatus(user.id)}
                          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white rounded-lg transition-colors"
                          style={{ backgroundColor: user.is_active ? '#10b981' : '#6b7280' }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = user.is_active ? '#059669' : '#4b5563'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = user.is_active ? '#10b981' : '#6b7280'}
                          title={user.is_active ? 'Désactiver' : 'Activer'}
                        >
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {user.is_active ? (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                            ) : (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            )}
                          </svg>
                          {user.is_active ? 'Désactiver' : 'Activer'}
                        </button>

                        {/* Bouton Supprimer - Rouge/Danger */}
                        <button
                          onClick={() => handleDeleteClick(user)}
                          className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white rounded-lg transition-colors"
                          style={{ backgroundColor: '#ef4444' }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#dc2626'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#ef4444'}
                          title="Supprimer"
                        >
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                          Supprimer
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between mt-4 px-4 py-3">
            <div className="text-sm text-gray-700">
              Affichage de {startIndex + 1} à {Math.min(endIndex, filteredUsers.length)} sur {filteredUsers.length} utilisateur{filteredUsers.length > 1 ? 's' : ''}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                className="btn btn-secondary text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Précédent
              </button>
              <span className="flex items-center px-4 text-sm text-gray-700">
                Page {currentPage} sur {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                className="btn btn-secondary text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Suivant
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal d'ajout/modification */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => { setShowAddModal(false); resetForm(); }}>
          <div className="modal-content max-w-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                {editingUser ? 'Modifier un utilisateur' : 'Créer un utilisateur'}
              </h3>
              <button
                className="text-gray-400 hover:text-gray-600"
                onClick={() => { setShowAddModal(false); resetForm(); }}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="modal-body">
              <div className="modal-form-group">
                <label className="modal-form-label">Nom complet *</label>
                <input
                  type="text"
                  className="modal-form-input"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  placeholder="Ex: Jean Kouassi"
                />
              </div>

              <div className="modal-form-group">
                <label className="modal-form-label">Email *</label>
                <input
                  type="email"
                  className="modal-form-input"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  placeholder="Ex: jean.kouassi@example.com"
                />
              </div>

              <div className="modal-form-group">
                <label className="modal-form-label">
                  Mot de passe {editingUser ? '(laisser vide pour ne pas modifier)' : '*'}
                </label>
                <input
                  type="password"
                  className="modal-form-input"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required={!editingUser}
                  minLength={8}
                  placeholder="Minimum 8 caractères"
                />
                {editingUser && (
                  <p className="text-sm text-gray-500 mt-1">
                    Laissez vide si vous ne souhaitez pas modifier le mot de passe
                  </p>
                )}
              </div>

              <div className="modal-form-group">
                <label className="modal-form-label">Téléphone</label>
                <input
                  type="tel"
                  className="modal-form-input"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="Ex: +241 07 12 34 56"
                />
              </div>

              <div className="modal-form-group">
                <label className="modal-form-label">Type d'utilisateur *</label>
                <select
                  className="modal-form-select"
                  value={formData.user_type}
                  onChange={(e) => setFormData({ ...formData, user_type: e.target.value })}
                  required
                  disabled={editingUser !== null} // Ne pas permettre de changer le type lors de la modification
                >
                  <option value="customer">Acheteur</option>
                  <option value="supplier">Fournisseur</option>
                  <option value="delivery_person">Livreur</option>
                  <option value="admin">Administrateur</option>
                </select>
                {!editingUser && (
                  <p className="text-sm text-gray-500 mt-1">
                    Note: Les acheteurs peuvent s'inscrire eux-mêmes. Vous pouvez créer des fournisseurs et des livreurs.
                  </p>
                )}
                {editingUser && (
                  <p className="text-sm text-gray-500 mt-1">
                    Le type d'utilisateur ne peut pas être modifié après la création.
                  </p>
                )}
              </div>

              <div className="modal-form-group">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                    className="mr-2"
                  />
                  <span className="modal-form-label">Compte actif</span>
                </label>
              </div>

              <div className="modal-form-group">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={formData.is_verified}
                    onChange={(e) => setFormData({ ...formData, is_verified: e.target.checked })}
                    className="mr-2"
                  />
                  <span className="modal-form-label">Compte vérifié</span>
                </label>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => { setShowAddModal(false); resetForm(); }}
                  className="btn btn-secondary"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  {editingUser ? 'Modifier' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de détails */}
      {showDetailsModal && selectedUser && (
        <div className="modal-overlay" onClick={() => setShowDetailsModal(false)}>
          <div className="modal-content max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Détails de l'Utilisateur</h3>
              <button
                className="text-gray-400 hover:text-gray-600"
                onClick={() => setShowDetailsModal(false)}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="modal-body">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Informations de base */}
                <div className="space-y-4">
                  <h4 className="font-semibold text-lg text-gray-900 mb-4">Informations Personnelles</h4>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Nom complet</label>
                    <p className="text-gray-900">{selectedUser.name || 'N/A'}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Email</label>
                    <p className="text-gray-900">{selectedUser.email || 'N/A'}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Téléphone</label>
                    <p className="text-gray-900">{selectedUser.phone || 'N/A'}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Type d'utilisateur</label>
                    <p>{getUserTypeBadge(selectedUser.user_type)}</p>
                  </div>
                </div>

                {/* Statut et dates */}
                <div className="space-y-4">
                  <h4 className="font-semibold text-lg text-gray-900 mb-4">Statut et Dates</h4>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Statut</label>
                    <p>{getStatusBadge(selectedUser.is_active)}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Compte vérifié</label>
                    <p className="text-gray-900">
                      {selectedUser.is_verified ? (
                        <span className="badge badge-success">Oui</span>
                      ) : (
                        <span className="badge badge-warning">Non</span>
                      )}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">Date d'inscription</label>
                    <p className="text-gray-900">{formatDate(selectedUser.created_at)}</p>
                  </div>
                  {selectedUser.last_login_at && (
                    <div>
                      <label className="text-sm font-medium text-gray-500">Dernière connexion</label>
                      <p className="text-gray-900">{formatDate(selectedUser.last_login_at)}</p>
                    </div>
                  )}
                </div>

                {/* Profil utilisateur */}
                {selectedUser.profile && (
                  <div className="space-y-4 md:col-span-2">
                    <h4 className="font-semibold text-lg text-gray-900 mb-4">Profil Utilisateur</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {selectedUser.profile.address && (
                        <div>
                          <label className="text-sm font-medium text-gray-500">Adresse</label>
                          <p className="text-gray-900">{selectedUser.profile.address}</p>
                        </div>
                      )}
                      {selectedUser.profile.city && (
                        <div>
                          <label className="text-sm font-medium text-gray-500">Ville</label>
                          <p className="text-gray-900">{selectedUser.profile.city}</p>
                        </div>
                      )}
                      {selectedUser.profile.region && (
                        <div>
                          <label className="text-sm font-medium text-gray-500">Région</label>
                          <p className="text-gray-900">{selectedUser.profile.region}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Statistiques (si applicable) */}
                {selectedUser.user_type === 'customer' && (
                  <div className="space-y-4 md:col-span-2">
                    <h4 className="font-semibold text-lg text-gray-900 mb-4">Statistiques</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <label className="text-sm font-medium text-gray-500">Commandes</label>
                        <p className="text-2xl font-bold text-gray-900">{selectedUser.orders_count || 0}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                onClick={() => setShowDetailsModal(false)}
                className="btn btn-secondary"
              >
                Fermer
              </button>
              <button
                onClick={() => {
                  setShowDetailsModal(false);
                  handleEdit(selectedUser);
                }}
                className="btn btn-primary"
              >
                Modifier
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de confirmation de suppression */}
      {showDeleteModal && selectedUser && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content max-w-md" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Confirmer la suppression</h3>
              <button
                className="text-gray-400 hover:text-gray-600"
                onClick={() => setShowDeleteModal(false)}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="modal-body">
              <p className="text-gray-700">
                Êtes-vous sûr de vouloir supprimer l'utilisateur <strong>{selectedUser.name}</strong> ?
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Cette action est irréversible. Toutes les données associées à cet utilisateur seront également supprimées.
              </p>
            </div>

            <div className="modal-footer">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="btn btn-secondary"
              >
                Annuler
              </button>
              <button
                onClick={handleDelete}
                className="btn btn-danger"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUsers;
